import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Advisor } from '../../customer-admin.model';

export const getAdvisor = createAction('[Advisor/API] GET Advisor');

export const putAdvisor = createAction(
    '[Advisor/API] PUT Advisor',
    props<{ JsonString: any }>()
);

export const loadAdvisors = createAction(
    '[Advisor/API] Load Advisors',
    props<{ Advisors: any[] }>()
);

export const addAdvisor = createAction(
    '[Advisor/API] Add Advisor',
    props<{ Advisor: Advisor }>()
);

export const upsertAdvisor = createAction(
    '[Advisor/API] Upsert Advisor',
    props<{ Advisor: Advisor }>()
);

export const addAdvisors = createAction(
    '[Advisor/API] Add Advisors',
    props<{ Advisors: Advisor[] }>()
);

export const upsertAdvisors = createAction(
    '[Advisor/API] Upsert Advisors',
    props<{ Advisors: Advisor[] }>()
);

export const updateAdvisor = createAction(
    '[Advisor/API] Update Advisor',
    props<{ Advisor: Update<Advisor> }>()
);

export const updateAdvisors = createAction(
    '[Advisor/API] Update Advisors',
    props<{ Advisors: Update<Advisor>[] }>()
);

export const deleteAdvisor = createAction(
    '[Advisor/API] Delete Advisor',
    props<{ id: string }>()
);

export const deleteAdvisors = createAction(
    '[Advisor/API] Delete Advisors',
    props<{ ids: string[] }>()
);

export const clearAdvisors = createAction('[Advisor/API] Clear Advisors');
